import React, { useEffect, useState } from "react";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import LessonFooterNav from "components/NavigationButton/LessonFooterNav.js";
import PromptLabHubComponent from "components/PromptLabHub/PromptLabHubComponent.js";
import { getV2LessonMetaByRoute, getNextV2LessonRoute } from "pages/claudeDevV2Course/devV2LessonsRegistry.js";

const ROUTE = "V2_M1_L1";

const V2_M1_L1Component = ({ setAiPageContext, setCurrentCode, setCurrentOuput }) => {
    const meta = getV2LessonMetaByRoute(ROUTE);
    const nextRoute = getNextV2LessonRoute(ROUTE);
    const [allCompleted, setAllCompleted] = useState(false);

    useEffect(() => {
        setAiPageContext?.("claudeCourseLesson");
    }, [setAiPageContext]);

    return (
        <div className="lessonBackgroundColor1 lessonMain" style={{ minHeight: "100vh" }}>
            <LessonNavBar />
            <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
                <section>
                    <PromptLabHubComponent
                        lessonMeta={meta}
                        setallCheckboxesCompleted={setAllCompleted}
                        setCurrentCode={setCurrentCode}
                        setCurrentOuput={setCurrentOuput}
                    />
                </section>
                <LessonFooterNav route={ROUTE} nextRoute={nextRoute} showNext={allCompleted} />
            </main>
        </div>
    );
};

export default V2_M1_L1Component;
